// app/javascript/projects/components/TranscriptNotFound.jsx

import React from 'react';
import FullPageMessage from './FullPageMessage';
import { useProjectModal } from '../../contexts/ProjectModalContext';

function TranscriptNotFound() {
  const { showProjectModal } = useProjectModal();
  
  return (
    <FullPageMessage
      header='Transcript not Found'
      body='You do not have access to this transcript or it does not exist.'
      onClick={showProjectModal}
      buttonText='See Your Projects'
    />
  );
}

export default TranscriptNotFound;